import React, { useState, useMemo } from 'react';
import CalcShell from '../CalcShell';
import { CalcNetPanel, Row, UnitInput, FeetInches, RadioGroup, ResultTable } from '../_fitnessHelpers';

export default function OverweightCalc() {
  const [tab, setTab] = useState(0);
  const [age, setAge] = useState(30);
  const [gender, setGender] = useState('male');
  const [ft, setFt] = useState(5);
  const [inches, setInches] = useState(10);
  const [lb, setLb] = useState(200);
  const [cm, setCm] = useState(178);
  const [kg, setKg] = useState(90);
  const clear = () => { setAge(30); setGender('male'); setFt(5); setInches(10); setLb(200); setCm(178); setKg(90); };
  const c = useMemo(() => {
    const h = tab === 0 ? ((+ft||0)*12+(+inches||0))*0.0254 : (+cm||0)/100;
    const w = tab === 0 ? (+lb||0)*0.453592 : +kg||0;
    const bmi = h > 0 ? w/(h*h) : 0;
    const healthyMax = 24.9 * h * h;
    const excess = Math.max(0, w - healthyMax);
    let cat, color;
    if (bmi < 18.5) { cat = 'Underweight'; color = '#3b82f6'; }
    else if (bmi < 25) { cat = 'Healthy weight'; color = '#2f9c3f'; }
    else if (bmi < 30) { cat = 'Overweight'; color = '#e39024'; }
    else if (bmi < 35) { cat = 'Obese Class I'; color = '#c86870'; }
    else if (bmi < 40) { cat = 'Obese Class II'; color = '#a63946'; }
    else { cat = 'Obese Class III'; color = '#8b1e2f'; }
    const disp = k => tab === 0 ? `${(k/0.453592).toFixed(1)} lb` : `${k.toFixed(1)} kg`;
    return { bmi, cat, color, healthyMax, excess, disp };
  }, [tab, ft, inches, lb, cm, kg]);

  return (
    <CalcShell look="cnet" title="Overweight Calculator" subtitle="Check if you're overweight and estimate the excess weight above the healthy BMI cap.">
      <CalcNetPanel slug="ow" activeTab={tab} onTabChange={setTab} onClear={clear} right={
        <div>
          <div className="text-lg text-slate-800">Your BMI</div>
          <div className="text-2xl font-bold" style={{color: c.color}} data-testid="ow-bmi">{c.bmi.toFixed(2)} kg/m²</div>
          <div className="mt-1 font-semibold" style={{color: c.color}}>Category: {c.cat}</div>
          <ResultTable testid="ow-detail-table" rows={[
            ['Healthy weight cap (BMI 24.9)', c.disp(c.healthyMax)],
            ['Excess weight to lose', <span className="font-bold text-red-600">{c.disp(c.excess)}</span>],
          ]}/>
        </div>
      }>
        <Row label="Age"><UnitInput value={age} onChange={setAge} testid="ow-age"/></Row>
        <Row label="Gender"><RadioGroup name="ow-g" value={gender} onChange={setGender} options={[{value:'male',label:'male'},{value:'female',label:'female'}]}/></Row>
        {tab === 0 ? <>
          <Row label="Height"><div className="grid grid-cols-2 gap-2 flex-1"><FeetInches ft={ft} inches={inches} onFt={setFt} onIn={setInches} testidPrefix="ow-h"/></div></Row>
          <Row label="Weight"><UnitInput value={lb} onChange={setLb} unit="pounds" testid="ow-w"/></Row>
        </> : <>
          <Row label="Height"><UnitInput value={cm} onChange={setCm} unit="cm" testid="ow-hcm"/></Row>
          <Row label="Weight"><UnitInput value={kg} onChange={setKg} unit="kg" testid="ow-wkg"/></Row>
        </>}
      </CalcNetPanel>
    </CalcShell>
  );
}
